/**
 * Add a new underwriter
 *
 * @param underwriter
 * @returns {function(*)}
 */
import {addNotification as notify} from 'reapop';
import * as underwriterRateActions from "../graphql/actions/underwriterRate";
import l10n from "../l10n/localization";
import * as types from "../constants/actionTypes";
import * as creationActions from "./creation";
import * as ajaxRoutes from "../constants/ajaxRoutes";
import * as authHandler from "../utils/authHandler";

export function add(rate) {
    return dispatch => {
        dispatch(loading());
        dispatch(saving(rate));
        underwriterRateActions.add(
            function (response) {
                dispatch(saved(response.data.createUnderwriterRate));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedUnderwriterRate(response.data.createUnderwriterRate));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            rate
        );
    };
}


export function edit(rate) {
    let id = rate.id;
    delete rate.id;
    delete rate.__typename;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(rate));
        underwriterRateActions.edit(
            function (response) {
                dispatch(saved(response.data.editUnderwriterRate));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            rate
        );
    };
}

export function fetchRates(companyId, force = false) {
    return dispatch => {
        dispatch(loading());
        underwriterRateActions.getRates(
            function (response) {
                dispatch(receiveUnderwriterRates(response.data.underwriterRates));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            companyId,
            force
        );
    };
}

export function deleteUnderwriterrate(underwriterrateID) {
    return dispatch => {
        let url = ajaxRoutes.API_ROUTE + "/underwriterrate/delete/"+underwriterrateID;
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});
        dispatch(deletingUnderwriterrate());
        fetch(url, {headers: headers})
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                dispatch(notify({message: l10n.messages.removed, status: 'success'}));
                return response;
            })
            .then((response) => {
                dispatch(doneDeletingUnderwriterrate());
                response.json().then(function(data) {
                    dispatch(fetchRates(data.client,true));
                });
            })
            .catch((error) => {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(doneDeletingUnderwriterrate());
            });
    };
}

export function deletingUnderwriterrate() {
    return {
        type: types.DELETING_UNDERWRITER_RATE
    };
}

export function doneDeletingUnderwriterrate() {
    return {
        type: types.DONE_DELETING_UNDERWRITER_RATE
    };
}


export function loading() {
    return {
        type: types.LOADING_UNDERWRITER_RATE
    };
}

export function saving(underwriterRate) {
    return {
        type: types.SAVING_UNDERWRITER_RATE,
        payload: underwriterRate
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_UNDERWRITER_RATES,
    };
}

export function saved(underwriterRate) {
    return {
        type: types.SAVED_UNDERWRITER_RATE,
        payload: underwriterRate
    };
}

export function receiveUnderwriterRates(data) {
    return {
        type: types.RECEIVED_UNDERWRITER_RATES,
        payload: data
    };
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}


// WEBPACK FOOTER //
// ./src/actions/underwriterRate.js